// orderLine model
const initialPeriodMonthlyPrice = ({ line, periodInMonths }) => {
  const { firstPeriodFree, rebatePrice, price } = line;

  if (firstPeriodFree) {
    return 0;
  }

  if (rebatePrice !== price) {
    return line.rebatePrice / periodInMonths;
  }

  return line.price / periodInMonths;
};

/**
 *
 * AC:
 * It should return 0 for the initial montly price if firstPeriodFree is 0
 * It should return the price for the initial period if firstPeriodFree is null
 */

export default function orderLine(orderLine, periodInMonths) {
  const product = {
    fullDomain: orderLine.fullDomain,
    total: orderLine.total,
    totalWithVAT: orderLine.totalWithVat,
    showWarning: orderLine.showBundleRemovalWarning,
    webSpaceSize: orderLine.webSpaceSize,
    lines: [],
    addonProducts: [],
  };

  // Lines
  product.lines = orderLine.lines.map((orderLine) => {
    if (orderLine.addOnProductType) {
      product.addonProducts.push(orderLine.addOnProductType);
    }

    return {
      text: orderLine.text, // ex: Hosting plan: Enthusiast - 3 months

      price: orderLine.price, // Original price for the initial period
      renewalPrice: orderLine.price, // Can this go?
      rebatePrice: orderLine.rebatePrice, // Rebate price for the initial period
      unitPrice: orderLine.unitPrice, // This is the price divided by storeFrontPriceInterval
      monthlyRenewalPrice: orderLine.monthlyRenewalPrice, // The price the products renews at, monthly
      yearlyRenewalPrice: orderLine.yearlyRenewalPrice, // The price the products renews at, yearly

      initialPeriodMonthlyPrice: initialPeriodMonthlyPrice({
        line: orderLine,
        periodInMonths: periodInMonths,
      }),
      numberOfMonthsInitialPeriod:
        orderLine.amountOfMonthsToPurchase === 0
          ? periodInMonths
          : orderLine.amountOfMonthsToPurchase,

      hasRebate:
        orderLine.price !== orderLine.rebatePrice &&
        orderLine.rebatePrice !== null,
      firstPeriodFree: orderLine.firstPeriodFree,

      referralTitle: orderLine.referralTitle,
      referralText: orderLine.referralText,
      referralUrl: orderLine.referralUrl,
      isReferral: orderLine.referralTitle !== "",

      isFree: orderLine.renewalPriceExVat === 0, // can this go? No, check this when implementing referral

      category: orderLine.category,
      mirrorPlanEnabled: orderLine.mirrorPlanEnabled,

      toolTipText: orderLine.toolTipText,
      hasTooltip: orderLine.toolTipText !== "",

      isAddonProduct: orderLine.addOnProductType !== null,
      addonProductName: orderLine.addOnProductType,
      vpsProduct: orderLine.vpsProduct || null,
    };
  });

  return product;
}
